import type { ReactElement } from 'react';

import { useI18n } from '#/i18n/hooks/useI18n';
import type { I18nFn } from '#/i18n/types/I18nFn';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

type Props = {
  render: (args: { i18n: I18nFn; locale: I18nLocale }) => ReactElement;
};

export function I18n({ render }: Props) {
  const { i18n, locale } = useI18n();
  return <>{render({ i18n, locale })}</>;
}
